// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"cc8d3bf3","508":"a5d38f42","568":"a5d38f42"}[chunkId] + ".chunk.css";
};